import { createApp } from "vue";
import PlanningApp from "@/vue/planning/App.vue"
import store from "@/vue/planning/store/store";
import ResidenceGallery from "@/vue/residence-gallery/App.vue";
import VCalendar from 'v-calendar';
import MapApp from "@/vue/map/App-v2.vue";
import VueGoogleMaps from "@fawmi/vue-google-maps"
import StationApp from "@/vue/station-domain/App.vue";
import ReviewApp from "@/vue/reviews/App.vue";
import storeReview from "@/vue/reviews/store/store.js";
import ClubAdvantagesApp from "@/vue/club-advantages/App.vue"
import TrainBanner from "@/vue/train-banner/App.vue"

const API_KEY = 'AIzaSyCOthaijtwQIXqc-nv6DRcEuUg62DqjheY';
const MAP_ID  = '326e7548c437d85e';

export default class AppInitializer {
	static singleton;


	constructor() {
		if (AppInitializer.singleton) {
			return AppInitializer.singleton
		}
		this._planningApp = null
		this._mainMapApp = null
		this._residenceGallery = null
		this._stationDomainMap = null
		this._reviewApp = null
		this._clubAdvantagesApp = null
		this._trainBanner = null
		
		AppInitializer.singleton = this
		return AppInitializer.singleton
	}
	get planningApp() {
		return this._planningApp
	}
	get mainMapApp() {
		return this._mainMapApp
	}
	get stationDomainMap() {
		return this._stationDomainMap
	}
	get reviewApp() {
		return this._reviewApp
	}
	get clubAdvantagesApp() {
		return this._clubAdvantagesApp
	}
	get residenceGallery() {
		return this._residenceGallery
	}
	get trainBanner() {
		return this._trainBanner
	}


	isAllAppsInitialized() {
		return [
			this._planningApp,
			this._residenceGallery,
			this._mainMapApp,
			this._stationDomainMap,
			this._reviewApp,
			this._clubAdvantagesApp,
			this._trainBanner

		].every(Boolean);
		
	}
	

	/**
	 * @param {*} keyUpdater
	 */
	async initPlanningApp(keyUpdater) {
		if (this._planningApp) return
		const app = createApp(PlanningApp, { keyUpdater })
		app.use(store)
		app.use(VCalendar)
		app.mount('#planner-app')
		this._planningApp = app
	}		

	async forceAppReInit(appName, keyUpdater) {
		switch (appName) {
		  case 'planning':
			if (this._planningApp) {
			  // Vue3 unmount
			  this._planningApp.unmount()
			  this._planningApp = null
			}
			// Re-init with the (possibly new) keyUpdater
			await this.initPlanningApp(keyUpdater)
			break
	
		  default:
			throw new Error(`Re-init for "${appName}" not implemented`)
		}
		
	}
	async initMainMapApp() {
		if (this._mainMapApp) return
		const mapApp = createApp(MapApp);
		mapApp.use(VueGoogleMaps, {
			load: {
			  key: API_KEY,
			  mapId: MAP_ID,
			  v: 'weekly'        // ← get off of the retired 3.47 release
			},
			installComponents: true
		  });
		mapApp.mount('#tf-map--wrapper');
  		this._mainMapApp = mapApp;
	}

	async initStationDomainApp() {
		if (this._stationDomainMap) return
		const stationApp = createApp(StationApp)
		stationApp.mount("#station-app");
		this._stationDomainMap = stationApp;
	}

	async initReviewApp() {
		if (this._reviewApp) return;
		const currentType = window.screenSizeManager.screenType;
		storeReview.commit('setScreenType', currentType);
		const reviewApp = createApp(ReviewApp)
		reviewApp.use(storeReview)
		reviewApp.mount("#review-app");
		this._reviewApp = reviewApp;
	}

	async initResidenceGalerryApp() {
		if (this._residenceGallery) return
		const galleryApp = createApp(ResidenceGallery)
		galleryApp.mount('#residence-gallery-app')
		this._residenceGallery = galleryApp
	}

	async initClubAdvantagesApp() {
		if (this._clubAdvantagesApp) return
		const clubAdvantagesApp = createApp(ClubAdvantagesApp)
		clubAdvantagesApp.mount("#club-advantages-app")
		this._clubAdvantagesApp = clubAdvantagesApp
	}

	async initTrainBannerApp() {
		if (this._trainBanner) return
		const trainBanner = createApp(TrainBanner)
		trainBanner.mount("#trainBanner")
		this._trainBanner = trainBanner
	}

	async initAll() {
			await Promise.all([
				this.initPlanningApp(),
				this.initMainMapApp(),
			    this.initStationDomainApp(),
				this.initReviewApp(),

			])
		}
	
}
